module.exports = __webpack_public_path__ + "media/day/266-e22a0d73.svg";